const URL = {
	INDEX: '',
	HOME: '/:partner',
	FACILITYHOME: '/:partner/:facility',
	// BOOKING_PAGE1: '/:partner/booking/:event_id',
	// BOOKING_PAGE: 'booking',
	BOOKING_DETAIL1: '/:partner/event/:facility/:event_id',
	FACILITY_BOOKING_DETAIL1: '/:partner/:facility/bookingdetail',
	BOOKING_DETAIL: 'event',
	// FACILITY_BOOKING_DETAIL: ':facility/bookingdetail',

	FORGOT_PASSWORD: '/:partner/forgotpassword',
	FACILITY_FORGOT_PASSWORD: '/:partner/:facility/forgotpassword',
	PAYMENT_SUCCESS: '/:partner/paymentsuccess',
	FACILITY_PAYMENT_SUCCESS: '/:partner/:facility/paymentsuccess',
	PAYMENT_SUCCESS1: 'paymentsuccess',
	PAYMENT_FAIL: '/:partner/paymentfails',
	FACILITY_PAYMENT_FAIL: '/:partner/:facility/paymentfails',
	PAYMENT_FAIL2: 'paymentfails',
	RESET_PASSWORD: '/:partner/reset-password/:token_id',
	FACILITY_RESET_PASSWORD: '/:partner/reset-password/:token_id',
	NAVIGATING_PARTNER: '/navigating/:acc/:ref/:partner',
	NAVIGATING_MASQUERADE_PARTNER: '/navigating/:acc/:ref/:masquerade/:partner',
	INDEPENDANT_PASS_BOOKING: '/:partner/:facility/:independant_pass_id',
	INDEPENDANT_PASS_BOOKING_DETAILS: '/:partner/:facility/:independant_pass_id/bookingdetail',

	// account profile 
	PROFILE: '/profileUser',
	USER_ACCOUNT: '/userAccount',

	EXTERNAL: 'https://www.npmjs.com/package/qrcode.react',

	// EOS-973
	FISERV_IFRAME_FORMAT_URL: 'cardnumbernumericonly=true&useexpiryfield=true&useexpiry=true&usecvv=true&enhancedresponse=true&formatinput=true&maskfirsttwo=true&placeholder=Enter%20Card%20Number&cardlabel=Card%20Number%20*&cardinputmaxlength=19&expirylabel=Expiry%20Date%20*&cvvlabel=CVV%20*&placeholdermonth=MM&placeholderyear=YYYY&invalidinputevent=true&invalidcvvevent=true&invalidexpiryevent=true&onFormValid=true&placeholdercvv=511',
}

export default URL
